import React, { useContext } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Context } from '../../../context/AppContext';
import resizeImage from '../../../utils/resizeImage';
import generateProfileUrl from '../../../utils/profileUrl';
import filterProfileUrl from '../../../utils/filterProfileUrl';
import Truncate from '../../Truncate';
import RoundButton from '../../RoundButton';
import Reviews from './Reviews';
import PlaceholderLogo from '../../../assets/placeholderLogo.png';
import './styles.css';

const SponsoredItem = ({
  name,
  link,
  logo,
  listingId,
  suburbName,
  hash,
  state,
}) => {
  const {
    webp,
    media: { mobile },
  } = useContext(Context);

  return (
    <div
      className={classNames('SponsoredItem__root', {
        'SponsoredItem__root--mobile': mobile,
      })}
    >
      <div className="SponsoredItem__logo">
        <img
          src={
            logo
              ? resizeImage(logo, {
                  width: 130,
                  height: 130,
                  webp,
                })
              : PlaceholderLogo
          }
          alt={name}
        />
      </div>
      <div className="SponsoredItem__details">
        <div className="SponsoredItem__title">Localsearch Display Network</div>
        <Truncate lines={2}>
          <div className="SponsoredItem__name">{name}</div>
        </Truncate>
        {!!listingId && <Reviews listingId={listingId} />}
        <RoundButton size="smaller" className="SponsoredItem__linkText">
          View Profile <i className="icon-generalarrowelarge" />
        </RoundButton>
        <Link
          to={
            suburbName && state && name && hash
              ? generateProfileUrl({
                  name,
                  suburb: suburbName,
                  state,
                  hash,
                })
              : filterProfileUrl(link)
          }
          className="SponsoredItem__link"
        >
          {name}
        </Link>
      </div>
    </div>
  );
};

export default SponsoredItem;
